export enum HomeScreenMode {
    Default = 0,
    Cards,
    Dashboard,
}